import { useTranslation } from 'react-i18next';

export default function Problem() {
  const { t } = useTranslation('common');

  const problemText = t('problem.paragraph1');
  const lines = problemText.split('\n').filter(line => line.trim());
  const intro = lines[0];
  const listItems = lines.slice(1, -1);
  const conclusion = lines[lines.length - 1];

  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {t('problem.title')}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              {intro}
            </p>
            <ul className="text-lg text-gray-700 leading-relaxed mb-6 space-y-2">
              {listItems.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-lg text-gray-700 leading-relaxed">
              {conclusion.split('operasi ikut berhenti').length > 1 ? (
                <>
                  {conclusion.split('operasi ikut berhenti')[0]}
                  <strong>operasi ikut berhenti</strong>
                  {conclusion.split('operasi ikut berhenti')[1]}
                </>
              ) : conclusion.split('operations stop').length > 1 ? (
                <>
                  {conclusion.split('operations stop')[0]}
                  <strong>operations stop</strong>
                  {conclusion.split('operations stop')[1]}
                </>
              ) : (
                conclusion
              )}
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/74dca0d67a7fa60a0bc43d172f435145.jpg" 
              alt="Monitoring Dashboard Alerts" 
              className="w-full h-full object-cover object-center rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
